module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /home/mudassir/.nvm/v8.7.0/lib/node_modules/react-scripts/node_modules/babel-runtime/regenerator/index.js
// module id = 1402
// module chunks = 0